import * as microsoftTeams from "@microsoft/teams-js";
import {
  CALENDARS_ROOT_PATH,
  BOOKINGS_ROOT_PATH,
} from "../../../../lib/routes/routes";
import { openAuthPopup } from "../../../../lib/utils/openAuthPopup";
import {
  buildTeamsO365AuthStartUrl,
  TEAMS_O365_AUTH_STATE,
} from "../../../../lib/utils/teamsAuth";
import { config } from "./o365-config";

const shouldUseTeamsDesktopAuth = async () => {
  if (!microsoftTeams.app.isInitialized()) {
    return false;
  }

  try {
    const context = await microsoftTeams.app.getContext();

    return context.app.host.clientType !== microsoftTeams.HostClientType.web;
  } catch (error) {
    return false;
  }
};

export const redirectToO365 = async (
  type: string,
  openEnvironment: boolean,
  calendarId?: string
) => {
  const clientId = ["personal", "reAuth"].includes(type)
    ? config.appUserId
    : config.appId;
  let redirectUrl: string;

  switch (type) {
    case "personal":
    case "reAuth":
      redirectUrl = `${config.redirectUri}${BOOKINGS_ROOT_PATH}/?complete=0365`;
      break;
    default:
      redirectUrl = `${
        config.redirectUri
      }${CALENDARS_ROOT_PATH}/?complete=0365${
        openEnvironment ? "_custom" : ""
      }`;
      break;
  }

  const useTeamsDesktopAuth = await shouldUseTeamsDesktopAuth();
  const teamsAuthState = useTeamsDesktopAuth
    ? `&state=${TEAMS_O365_AUTH_STATE}`
    : "";
  const uri = encodeURI(
    `https://login.microsoftonline.${
      openEnvironment ? "us" : "com"
    }/organizations/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUrl}&response_mode=fragment&scope=${
      config.scopes
    }&prompt=select_account${teamsAuthState}`
  );

  if (type === "admin") {
    localStorage.setItem("calendarId", calendarId || "");
  }

  if (type === "reAuth") {
    localStorage.setItem("initiateO365ReAuth", "1");
  }

  if (useTeamsDesktopAuth) {
    try {
      const teamsAuthStartUrl = buildTeamsO365AuthStartUrl(redirectUrl, uri);
      const href = await microsoftTeams.authentication.authenticate({
        url: teamsAuthStartUrl,
        width: 600,
        height: 700,
      });

      if (href) {
        window.location.href = href;
      }
    } catch (error) {
      console.error("Microsoft Teams O365 authentication failed:", error);
    }

    return;
  }

  openAuthPopup(uri, {
    windowName: "o365-auth",
    matchUrl: (href) => href.includes("complete=0365"),
    onMatch: (href) => {
      window.location.href = href;
    },
    fallbackUrl: uri,
    onBlocked: () => {
      window.location.replace(uri);
    },
  });
};
